module.exports = __webpack_public_path__ + "img/guangGong4.acc2e794.png";